/* src/app/opportunities/pages/add-opportunities/add-opportunities.component.scss */
/*# sourceMappingURL=add-opportunities.component.css.map */
